
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

import { defineComponent, shallowRef, PropType } from 'vue'

// Composables
import { useProject } from '@/org/use-projects'
import { useMonitorManager } from '@/alerting/use-monitors'

// Misc
import { MetricMonitor, Monitor } from '@/alerting/types'

export default defineComponent({
  name: 'MonitorMetricFormPanes',
  components: {
    Splitpanes,
    Pane,
  },

  props: {
    monitor: {
      type: Object as PropType<MetricMonitor>,
      required: true,
    },
    maxWidth: {
      type: Number,
      default: 1416,
    },
  },

  setup(props, ctx) {
    const form = shallowRef()
    const isValid = shallowRef(false)

    const project = useProject()
    const monitorMan = useMonitorManager()
    function submit() {
      if (!form.value.validate()) {
        return
      }

      save().then((monitor: Monitor) => {
        ctx.emit('saved', monitor)
      })
    }
    function save() {
      if (props.monitor.id) {
        return monitorMan.updateMetricMonitor(props.monitor)
      }
      return monitorMan.createMetricMonitor(props.monitor)
    }

    return {
      form,
      isValid,

      project,
      monitorMan,
      submit,
    }
  },
})
